export default "__VITE_ASSET__7h1j3vm1__"